import CoreAdmin from './CoreAdmin';
import CoreAdminContext from './CoreAdminContext';
import CoreAdminRouter from './CoreAdminRouter';
import CoreAdminUI from './CoreAdminUI';
import createAdminStore from './createAdminStore';
import RoutesWithLayout from './RoutesWithLayout';
import Resource from './Resource';
export { CoreAdmin, CoreAdminContext, CoreAdminRouter, CoreAdminUI, createAdminStore, RoutesWithLayout, Resource, };



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/core/components.js
// module id = 648
// module chunks = 0